import { loadScript, removeScript } from '@/shared/lib/analytics/scriptLoader'
import {
  configString,
  type AnalyticsEventProps,
  type AnalyticsProvider,
  type AnalyticsProviderConfig,
} from '@/shared/lib/analytics/types'

const SCRIPT_ID = 'cse-analytics-plausible'

export function createPlausibleProvider(): AnalyticsProvider {
  return {
    key: 'plausible',
    load(config: AnalyticsProviderConfig): void {
      // Queue stub so calls made before the script loads are replayed by it.
      if (window.plausible === undefined) {
        const stub = ((...args: unknown[]) => {
          ;(stub.q ??= []).push(args)
        }) as NonNullable<Window['plausible']>
        window.plausible = stub
      }
      loadScript(SCRIPT_ID, configString(config, 'script_url'), {
        'data-domain': configString(config, 'domain'),
      }).catch(() => undefined)
    },
    unload(): void {
      removeScript(SCRIPT_ID)
      delete window.plausible
    },
    pageview(path: string): void {
      window.plausible?.('pageview', { u: `${window.location.origin}${path}` })
    },
    track(name: string, props?: AnalyticsEventProps): void {
      window.plausible?.(name, props === undefined ? undefined : { props })
    },
  }
}
